var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("全支付說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用全支付恕不適用分期付款。")]),_c('li',[_vm._v("消費可使用全點折抵訂單金額。")]),_c('li',[_vm._v("可使用全支付帳戶、連結銀行帳戶或綁定信用卡付款。")]),_c('li',[_vm._v("於訂單成立後 20 分鐘內須完成付款。")]),_c('li',[_vm._v("付款額度及使用限制：詳參全支付 APP > 我的 > 本月額度或常見問題")])])])
}]

export { render, staticRenderFns }